"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const react_1 = __importStar(require("react"));
const ChartSection_1 = __importDefault(require("../../components/ChartSection"));
const HomepageIcon_1 = __importDefault(require("../../components/HomepageIcon"));
const Page_1 = __importDefault(require("../../components/Page"));
const Slider_1 = __importDefault(require("../../components/Slider"));
const Title_1 = __importDefault(require("../../components/Title"));
const useWindowDimension_1 = __importDefault(require("../../utils/hooks/useWindowDimension"));
require("./Home.sass");
const getDataArrayByCategory = (category) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield axios_1.default.get(`/api/load-homepage/${category}`)).data;
});
const Home = () => {
    const { height } = (0, useWindowDimension_1.default)();
    const [selectedCategory, setSelectedCategory] = (0, react_1.useState)("HEALTH");
    const [activeData, setActiveData] = (0, react_1.useState)({
        text: "",
        color: "",
        colorArray: [""],
        data: [],
    });
    (0, react_1.useEffect)(() => {
        getDataArrayByCategory(selectedCategory).then((res) => {
            let data = homepageDataArray[selectedCategory];
            setActiveData({
                text: data.text,
                color: data.color,
                colorArray: data.colorArray,
                data: res.slice(0, 6),
            });
        });
    }, [selectedCategory]);
    const icons = [
        {
            text: "Santé et nutrition",
            category: "HEALTH",
            path: "/icons/health.svg",
            bgColor: "#006838",
            color: "#ffffff",
        },
        { text: "Education", category: "EDUCAT", path: "/icons/education.svg", bgColor: "#BD202E", color: "#ffffff" },
        {
            text: "Protection de l'enfant",
            category: "CHILDP",
            path: "/icons/childprotection.svg",
            bgColor: "#F6921E",
            color: "#ffffff",
        },
        {
            text: "Eau, assainissement et hygiène",
            category: "ENVIRO",
            path: "/icons/environment.svg",
            bgColor: "#1B75BB",
            color: "#ffffff",
        },
        {
            text: "Politique sociale",
            category: "SOCIAL",
            path: "/icons/social.svg",
            bgColor: "#754C28",
            color: "#ffffff",
        },
        {
            text: "Participation et droits civils",
            category: "CIVILR",
            path: "/icons/civilrights.svg",
            bgColor: "#37B34A",
            color: "#ffffff",
        },
    ];
    const homepageDataArray = {
        "": {
            text: "",
            color: "",
            colorArray: [""],
            data: [],
        },
        HEALTH: {
            text: "Santé et nutrition",
            color: "#006838",
            colorArray: ["#006838", "#9eb0a2", "#6a7b6f", "#006697", "#0099ce"],
            data: [],
        },
        EDUCAT: {
            text: "Education",
            color: "#BD202E",
            colorArray: ["#bd202e", "#57423f", "#bfa5a3", "#3f6e00", "#76a215"],
            data: [],
        },
        CHILDP: {
            text: "Protection des enfants",
            color: "#F6921E",
            colorArray: ["#F6921E", "#524439", "#b9a89b", "#00c670", "#008e3e"],
            data: [],
        },
        ENVIRO: {
            text: "Eau, assainissement et hygiène",
            color: "#1b75bb",
            colorArray: ["#1b75bb", "#3e4756", "#a2acbd", "#b35072", "#ee85a6"],
            data: [],
        },
        SOCIAL: {
            text: "Protection sociale et pauvreté des enfants",
            color: "#754C28",
            colorArray: ["#754C28", "#baa89b", "#847468", "#24603f", "#57936e"],
            data: [],
        },
        CIVILR: {
            text: "Participation et droits civils",
            color: "#37B34A",
            colorArray: ["#37B34A", "#3e4a3d", "#a1afa0", "#00b5ff", "#0080c6"],
            data: [],
        },
    };
    return (react_1.default.createElement(Page_1.default, { currentLink: "home" },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Slider_1.default, { category: "GLOBAL", height: height - 220 }),
            react_1.default.createElement("main", { className: "m-auto h-full w-full max-w-7xl py-0 px-8" },
                react_1.default.createElement(Title_1.default, { text: "Mauritanie" }),
                react_1.default.createElement(Title_1.default, { text: "" }),
                react_1.default.createElement("section", { className: "w-full flex flex-col lg:flex-row" },
                    react_1.default.createElement("aside", { className: "flex lg:flex-col flex-wrap" }, icons.map((icon) => {
                        return (react_1.default.createElement(HomepageIcon_1.default, { key: icon.category, text: icon.text, bgColor: icon.bgColor, category: icon.category, path: icon.path, color: icon.color, setSelectedCategory: setSelectedCategory, selectedCategory: selectedCategory }));
                    })),
                    react_1.default.createElement("div", { className: "bg-slate-200 w-full" },
                        react_1.default.createElement(ChartSection_1.default, { text: activeData.text, textColor: `text-[${activeData.color}]`, bgColor: `before:bg-[${activeData.color}]`, bgColorArray: activeData.colorArray, dataArray: activeData.data })))))));
};
exports.default = Home;
